import { Type } from "@sinclair/typebox";
import type { Static } from "@sinclair/typebox";
import { CreateSessionBodySchema, parseContract } from "@rnavoyager/contracts";
import type { CreateSessionBody } from "@rnavoyager/contracts";

const PREFIX = "rnavoyager.submission.";
const WINDOW_MS = 24 * 60 * 60_000;
const PendingSchema = Type.Object(
  { request: CreateSessionBodySchema, savedAt: Type.Number() },
  { additionalProperties: false },
);

/** 只保留未确认的文本与幂等键；文件字节和凭据不进入浏览器存储。 */
export function rememberSubmission(userId: string, request: CreateSessionBody): void {
  sessionStorage.setItem(PREFIX + userId, JSON.stringify({ request, savedAt: Date.now() }));
}

export function pendingSubmission(userId: string): CreateSessionBody | null {
  const key = PREFIX + userId;
  const raw = sessionStorage.getItem(key);
  if (!raw) return null;
  try {
    const pending = parseContract<Static<typeof PendingSchema>>(PendingSchema, JSON.parse(raw));
    if (Date.now() - pending.savedAt >= WINDOW_MS || pending.savedAt > Date.now()) {
      sessionStorage.removeItem(key);
      return null;
    }
    return pending.request;
  } catch {
    sessionStorage.removeItem(key);
    return null;
  }
}

export function forgetSubmission(userId: string): void {
  sessionStorage.removeItem(PREFIX + userId);
}

export function forgetAllSubmissions(): void {
  for (const key of Object.keys(sessionStorage))
    if (key.startsWith(PREFIX)) sessionStorage.removeItem(key);
}
